import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { ContactData } from '../data-models/contactData';

@Injectable({
  providedIn: 'root'
})
export class ContactUsService {
  private baseUrl: string | undefined;
  private ContactInfoSource=new BehaviorSubject<ContactData|null>(null);
  contactInfo$=this.ContactInfoSource.asObservable();
  constructor(private http: HttpClient) {
    this.baseUrl = environment.apiUrl;
   }

  getMessageTypes(): Observable<Response> {
    const url = `${this.baseUrl}api/WebsiteMessages/GetMessageTypes`;
    return this.http.get<Response>(url);
  }
  createMessage(messageData:any): Observable<Response> {
    const url = `${this.baseUrl}api/WebsiteMessages/CreateMessage`;

    return this.http.post<Response>(url, messageData);
  }
  getContactInfo(): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}api/WebsiteSettings/GetContactInfo`);
  }
  setContactInfo() {
    this.getContactInfo().subscribe(
      (res: any) => {
        this.ContactInfoSource.next(res.data);
      },
      (error) => {
        console.error('Error fetching contact info', error);
        this.ContactInfoSource.next(null);
      }
    );
  }
}
